{
  "claimTypesMultiSelectConfig": {
    "dataSource": [
      {
        "index": "1",
        "name": "Accd. Discharge From Plumb/Heart/Air Cond.",
        "value": "Accd. Discharge From Plumb/Heart/Air Cond.",
        "checked": false
      },
      {
        "index": "2",
        "name": "Accident Involving Aircraft",
        "value": "Accident Involving Aircraft",
        "checked": false
      }
    ]
  },

  "injuredBodyPartTypesMultiSelectConfig": {
    "dataSource": [
      {
        "index": "1",
        "name": "Ankle",
        "value": "Ankle",
        "checked": false
      },
      {
        "index": "2",
        "name": "Brain",
        "value": "Brain",
        "checked": false
      }
    ]
  },

  "injuryTypesMultiSelectConfig": {
    "dataSource": [
      {
        "index": "1",
        "name": "Aids",
        "value": "Aids",
        "checked": false
      },
      {
        "index": "2",
        "name": "All Medical Malpractice",
        "value": "All Medical Malpractice",
        "checked": false
      }
    ]
  },

  "riskStateTypesMultiSelectConfig": {
    "dataSource": [
      {
        "index": "1",
        "name": "Alabama",
        "value": "Alabama",
        "checked": false
      },
      {
        "index": "2",
        "name": "Alaska",
        "value": "Alaska",
        "checked": false
      }
    ]
  },

  "claimantStateTypesMultiSelectConfig": {
    "dataSource": [
      {
        "index": "1",
        "name": "Alabama",
        "value": "Alabama",
        "checked": false
      },
      {
        "index": "2",
        "name": "Alaska",
        "value": "Alaska",
        "checked": false
      }
    ]
  },

  "policyNumberMultiSelectConfig": {
    "dataSource": [
      {
        "index": "1",
        "name": "20 UEN MS9081",
        "value": "20 UEN MS9081",
        "checked": false
      },
      {
        "index": "2",
        "name": "20 WN MS9080",
        "value": "20 WN MS9080",
        "checked": false
      }
    ]
  },

  "pricingPLanMultiSelectConfig": {
    "dataSource": [
      {
        "index": "1",
        "name": "Deductible",
        "value": "Deductible",
        "checked": false
      },
      {
        "index": "2",
        "name": "Guaranteed Cost",
        "value": "Guaranteed Cost",
        "checked": false
      }
    ]
  },

  "programPeriodMultiSelectConfig": {
    "dataSource": [
      {
        "index": "1",
        "name": "07/01/2010 - 07/01/2011",
        "value": "07/01/2010 - 07/01/2011",
        "checked": false
      },
      {
        "index": "2",
        "name": "07/01/2009 - 07/01/2010",
        "value": "07/01/2009 - 07/01/2010",
        "checked": false
      }
    ]
  },

  "disablityTypeMultiSelectConfig": {
    "dataSource": [
      {
        "index": "1",
        "name": "Death",
        "value": "Death",
        "checked": false
      },
      {
        "index": "2",
        "name": "Partial Disablity",
        "value": "Partial Disablity",
        "checked": false
      }
    ]
  },

  "benefitStateMultiSelectConfig": {
    "dataSource": [
      {
        "index": "1",
        "name": "Alabama",
        "value": "Alabama",
        "checked": false
      },
      {
        "index": "2",
        "name": "Alaska",
        "value": "Alaska",
        "checked": false
      }
    ]
  },

  "hireStateMultiSelectConfig": {
    "dataSource": [
      {
        "index": "1",
        "name": "Alabama",
        "value": "Alabama",
        "checked": false
      },
      {
        "index": "2",
        "name": "Alaska",
        "value": "Alaska",
        "checked": false
      }
    ]
  },

  "employmentDurationMultiSelectConfig": {
    "dataSource": [
      {
        "index": "1",
        "name": "0-6 Months",
        "value": "0-6 Months",
        "checked": false
      },
      {
        "index": "2",
        "name": "> 6 Months - 1 Year",
        "value": "> 6 Months - 1 Year",
        "checked": false
      }
    ]
  },

  "businessLineTypeMultiSelectConfig": {
    "dataSource": [
      {
        "index": "1",
        "name": "Auto Physical Damage",
        "value": "Auto Physical Damage",
        "checked": false
      },
      {
        "index": "2",
        "name": "Automobile Liability",
        "value": "Automobile Liability",
        "checked": false
      }
    ]
  },

  "claimSearchTypeMultiSelectConfig": {
    "dataSource": [
      {
        "index": "1",
        "name": "Accident Insurance",
        "value": "Accident Insurance",
        "checked": false
      },
      {
        "index": "2",
        "name": "Auto Collision",
        "value": "Auto Collision",
        "checked": false
      }
    ]
  },

  "policyPeriodTypeMultiSelectConfig": {
    "dataSource": [
      {
        "index": "1",
        "name": "07/01/2010 - 07/01/2011",
        "value": "07/01/2010 - 07/01/2011",
        "checked": false
      },
      {
        "index": "2",
        "name": "07/01/2009 - 07/01/2010",
        "value": "07/01/2009 - 07/01/2010",
        "checked": false
      }
    ]
  },

  "accidentStateTypeMultiSelectConfig": {
    "dataSource": [
      {
        "index": "1",
        "name": "Alabama",
        "value": "Alabama",
        "checked": false
      },
      {
        "index": "2",
        "name": "Alaska",
        "value": "Alaska",
        "checked": false
      }
    ]
  },

  "accidentDayTypeMultiSelectConfig": {
    "dataSource": [
      {
        "index": "1",
        "name": "Monday",
        "value": "Monday",
        "checked": false
      },
      {
        "index": "2",
        "name": "Tuesday",
        "value": "Tuesday",
        "checked": false
      }
    ]
  },

  "accidentDateTypeMultiSelectConfig": {
    "dataSource": [
      {
        "index": "1",
        "name": "After",
        "value": "After",
        "checked": false
      },
      {
        "index": "2",
        "name": "Before",
        "value": "Before",
        "checked": false
      }
    ]
  }
}